import React, { useEffect, useState } from "react"
import HomeContainer from "../Container/HomeContainer2"
import TeacherResume from "./TeacherResume.redux"
import Spinner from "../../Components/Spinner/Spinner"

//Yuan:redux
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
//Yuan-selector
import { selectUserDetails } from "../../redux/homePage/homePage.selectors"
import { updateToRoot } from "../../redux/homePage/homePage.actions"
import HoverIcon from "../../Components/FormField/HoverIcon-nova"
import Tour from "reactour"
import { API } from "../../API"
import EcecResumeContent from "./EcecResumeContent"

const Resume2 = ({ user, updateToRoot }) => {
  let [showTour, setShowTour] = useState(
    JSON.parse(window.localStorage.getItem('firstTime')) || false,
  )

  useEffect(() => {
    API.getUserSafeData().then(res => {
      updateToRoot(res.data?.user)
    })
  }, [])

  const tourSteps = [
    {
      content:
        (<React.Fragment>
            WAIT! We advise that you prepare your documents for uploading before completing the qualifications section
            of your Resume. Watch
            <b style={{color: "DodgerBlue", cursor: "pointer"}}
              onClick={() => window.open("https://drive.google.com/file/d/1f8JcC5u2RhEVAYvdi_BxVJRmQfYaz_He/view?usp=drivesdk", "_blank")}> this
              video </b>
            for instructions on reducing the file size of your documents.
          </React.Fragment>
        )
    },
  ]

  const closeTour = () => {
    setShowTour(false)
    window.localStorage.setItem('firstTime', 'false')
  }

  if (user) {
    return (
      <HomeContainer
        user={user}
        isViewAsTeacher={true}
        isShowWhereby={false}
        footer={null}
        isShowPoliceCheckWwcc={true}
        tabResumeActive={false}
        tabVetResumeActive={false}
        tabEcecResumeActive={true}
      >
        <div
          className="guide-tour-icon"
        >
          <HoverIcon
            icon="info"
            circular
            inverted
            className="search-help-icon"
            onClick={() => setShowTour(true)}
            text="Click for guide"
          />
        </div>
        <Tour
          showCloseButton={false}
          accentColor="#79cbca"
          className="tourContent"
          steps={tourSteps}
          isOpen={showTour}
          onRequestClose={closeTour}
        >
          <div className="tour-dot" onClick={closeTour} />
        </Tour>
        <EcecResumeContent
          user={user}
          isViewAsTeacher={true}
        />
      </HomeContainer>
    )
  }
  // else return <div>Loading</div>;
  else return <Spinner />
}

const mapStateToProps = createStructuredSelector({
  user: selectUserDetails,
})

const mapDispatchToProps = (dispatch) => ({
  updateToRoot: (user) =>
    dispatch(updateToRoot(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(Resume2)
